import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const ROLES = ['Кадастровый инженер', 'Нотариус', 'Оценщик / эксперт', 'Арбитражный управляющий', 'Судебный пристав',
  'Госорган / учреждение', 'Банк / МФО', 'Другое'];
const emptyForm = () => ({ role: ROLES[0], name: '', org: '', phone: '', email: '', note: '' });
const telHref = phone => 'tel:' + String(phone).split(/доб/i)[0].replace(/[^\d+]/g, '');

export default function ContactsPage() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState('');
  const [form, setForm] = useState(null);

  const load = () => api.get('/contacts').then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name.trim()) return alert('Укажите ФИО или название');
    if (form.id) await api.put(`/contacts/${form.id}`, form); else await api.post('/contacts', form);
    setForm(null); load();
  };
  const remove = async c => {
    if (!window.confirm(`Удалить контакт «${c.name}»?`)) return;
    await api.delete(`/contacts/${c.id}`); load();
  };
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const needle = q.trim().toLowerCase();
  const shown = list.filter(c => !needle || [c.role, c.name, c.org, c.phone, c.email, c.note].some(v => v && v.toLowerCase().includes(needle)));
  const groups = shown.reduce((g, c) => { (g[c.role] = g[c.role] || []).push(c); return g; }, {});

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 className="page-title">Контакты</h1>
        {!form && <button className="btn btn-primary" onClick={() => setForm(emptyForm())}>+ Добавить контакт</button>}
      </div>

      {form && (
        <div className="card" style={{ marginBottom: 16 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 12 }}>{form.id ? 'Редактирование' : 'Новый контакт'}</h3>
          <div className="form-row">
            <div className="form-group"><label>Кто это</label><input className="form-input" value={form.role} onChange={e => set('role', e.target.value)} list="contact-roles" /></div>
            <div className="form-group" style={{ flex: 2 }}><label>ФИО / название</label><input className="form-input" value={form.name} onChange={e => set('name', e.target.value)} autoFocus /></div>
          </div>
          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}><label>Организация, адрес</label><input className="form-input" value={form.org || ''} onChange={e => set('org', e.target.value)} /></div>
            <div className="form-group"><label>Телефон</label><input className="form-input" value={form.phone || ''} onChange={e => set('phone', e.target.value)} /></div>
            <div className="form-group"><label>E-mail</label><input className="form-input" value={form.email || ''} onChange={e => set('email', e.target.value)} /></div>
          </div>
          <div className="form-group"><label>Заметки</label><textarea className="form-input" rows={2} value={form.note || ''} onChange={e => set('note', e.target.value)} placeholder="Чем помогает, по какому делу, условия, часы работы" /></div>
          <datalist id="contact-roles">{ROLES.map(r => <option key={r} value={r} />)}</datalist>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" onClick={save}>Сохранить</button>
            <button className="btn btn-secondary" onClick={() => setForm(null)}>Отмена</button>
          </div>
        </div>
      )}

      <input className="form-input" placeholder="Поиск по имени, телефону, роли…" value={q} onChange={e => setQ(e.target.value)} style={{ marginBottom: 16, maxWidth: 400 }} />

      {Object.keys(groups).sort((a, b) => a.localeCompare(b, 'ru')).map(role => (
        <div className="card" key={role} style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6 }}>{role} <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>· {groups[role].length}</span></div>
          <div className="table-wrap"><table><tbody>
            {groups[role].map(c => (
              <tr key={c.id}>
                <td style={{ minWidth: 180 }}><strong>{c.name}</strong>{c.org && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{c.org}</div>}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{c.phone ? <a href={telHref(c.phone)} style={{ color: 'var(--accent)' }}>{c.phone}</a> : '—'}{c.email && <div style={{ fontSize: 12 }}><a href={`mailto:${c.email}`}>{c.email}</a></div>}</td>
                <td style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.note}</td>
                <td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                  <button className="btn btn-secondary btn-sm" onClick={() => { setForm({ ...c }); window.scrollTo(0, 0); }}>Изменить</button>{' '}
                  <button className="btn btn-secondary btn-sm" onClick={() => remove(c)}>Удалить</button>
                </td>
              </tr>
            ))}
          </tbody></table></div>
        </div>
      ))}
      {!shown.length && <div className="empty-state"><p>{list.length ? 'Ничего не найдено' : 'Контактов пока нет'}</p></div>}
    </div>
  );
}
